import { connect } from 'react-redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import isEmpty from 'ramda/es/isEmpty';
import path from 'ramda/es/path';

import { tariffsFetch } from 'app/actions/finances/tariffs';


export default compose(
  connect(
    (state, { studentId, service }) => ({
      noTariffs: isEmpty(state.finances.tariffs.tariffs),
      isOnlyOne: state.passages.data.count === 1,
      isSubscribe: !!path(['apps', 'data', service, studentId], state),
    })
  ),

  lifecycle({
    componentDidMount() {
      const { dispatch, service, studentId } = this.props;
      dispatch(tariffsFetch(service, studentId));
    },
    componentDidUpdate(prevProps) {
      const { dispatch, service, studentId, isSubscribe, isOnlyOne } = this.props;
      if (isSubscribe || !isOnlyOne) return;
      if (studentId !== prevProps.studentId && studentId) {
        dispatch(tariffsFetch(service, studentId));
      }
    },
  }),

  branch(
    ({ isSubscribe, isOnlyOne, noTariffs }) => (
      isSubscribe
      || !isOnlyOne
      || noTariffs
    ),
    renderNothing
  )
);
